import Axios from 'axios';
import React = require('react');

interface IProps {
    text: string;
    htmlTags?: boolean;
}

interface IState {

}

export default class TextSplitter extends React.Component<IProps, IState> {
    axios = Axios;

    render() {
        const htmlTags = this.props.htmlTags === true;
        if (!this.props.text) {
            return <></>;
        }
        return (
            <>
                {this.props.text.split('\n').map((s, i) => {
                    if (!s) { return <p key={i}>&nbsp;</p>; }

                    return htmlTags
                        ? <p key={i} dangerouslySetInnerHTML={{ __html: s }}></p>
                        : <p key={i}>{s}</p>;
                }
                )}
            </>
        );
    }
}
